import { render } from "./EditarGrupo.vue?vue&type=template&id=9c900b56&scoped=true"
import script from "./EditarGrupo.vue?vue&type=script&lang=js"
export * from "./EditarGrupo.vue?vue&type=script&lang=js"

import "./EditarGrupo.vue?vue&type=style&index=0&id=9c900b56&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c900b56"]])

export default __exports__